import React, { useEffect, useState } from 'react'
import profileBanner from '../../Assets/images/profile-bnr.webp'
import useMakeRequest from '../../utils/ApiHelper'
import { ApiConstants } from '../../constants/ApiConstants'
import FrontLoader from '../layout/FrontLoader'
import { useLocation, useParams } from 'react-router-dom'
import { getFromStorage } from '../../utils/Helper'

function Faq() {
    const FaqList = useMakeRequest()
    const [data, setData] = useState([])
      const path_name = useLocation()
      const Lang = getFromStorage({key: "Translate"})
     
      
    useEffect(() => {
        const payload = {
            "user_type": 1,
            lang_id:Lang == "spa" ? "2" : '1'
        }
        FaqList.makeRequest({ payload, url: ApiConstants?.Faqlist, toastStatus: false })
    }, [])
    useEffect(() => {
        if (FaqList?.status) {
            setData(FaqList?.data?.data)
        }
    }, [FaqList?.status])

    return (
        <>
        {FaqList?.loading ? <FrontLoader/> : null}
            <main>
                {/* top banner section start */}
                <section className="main-banner small-banner" style={{ background: `url(${profileBanner}) center/cover` }}>
                    <div className="container">
                        <h1 className="small-banner-heading">Faq's</h1>
                    </div>
                </section>
                {/* top banner section end */}
                <div className="container footer-space">
                    <div className="accordion faq-accordian" id="faqExample">
                        {data.length > 0 && data.map((res: any, i) => (
                            <div className="accordion-item" key={i}>
                                <h2 className="accordion-header" id={`heading${i}`}>
                                    <button
                                        className="accordion-button"
                                        type="button"
                                        data-bs-toggle="collapse"
                                        data-bs-target={`#collapse${i}`}
                                        aria-expanded="true"
                                        aria-controls={`collapse${i}`}
                                    >
                                        {res?.faqs_details?.question}
                                    </button>
                                </h2>
                                <div
                                    id={`collapse${i}`}
                                    className={`accordion-collapse collapse ${i === 0 ? 'show' : ''}`}
                                    aria-labelledby={`heading${i}`}
                                    data-bs-parent="#faqExample"
                                >
                                    <div className="accordion-body">
                                        {res?.faqs_details?.answer}
                                    </div>
                                </div>
                            </div>
                        ))}

                    </div>
                </div>
            </main>

        </>
    )
}

export default Faq